// extracted by mini-css-extract-plugin
export default {"item":"AttendanceItem_item__Xx+Q7","userContainer":"AttendanceItem_userContainer__qmbZQ","circleUser":"AttendanceItem_circleUser__8t1-g","icon":"AttendanceItem_icon__YCpX6"};